// src/modules/auth/components/GoogleLogin.tsx

import React from 'react';
import { GoogleLogin as GoogleOAuthLogin, CredentialResponse } from '@react-oauth/google';
import { useAppContext } from '../../../shared/context/AppContext';
import { authService } from '../services/authService';
import './GoogleLogin.css';

const GoogleLogin: React.FC = () => {
  const { state, dispatch } = useAppContext();
  const { auth } = state;

  const handleSuccess = async (credentialResponse: CredentialResponse) => {
    if (!credentialResponse.credential) {
      dispatch({
        type: 'AUTH_LOGIN_ERROR',
        payload: { error: 'No se recibió el token de Google' }
      });
      return;
    }

    dispatch({ type: 'AUTH_LOGIN_START' });

    try {
      console.log('🔐 Iniciando autenticación con Google...');
      
      // Enviar token directamente al backend
      // El backend se encarga de:
      // 1. Verificar el token con Google
      // 2. Verificar si el usuario existe en la BD
      // 3. Generar JWT si todo está correcto
      const authResponse = await authService.loginWithGoogle(credentialResponse.credential);
      
      if (authResponse.success && authResponse.data) {
        console.log('✅ Autenticación exitosa:', authResponse.data.user.email);
        
        dispatch({
          type: 'AUTH_LOGIN_SUCCESS',
          payload: {
            user: authResponse.data.user,
            token: authResponse.data.token
          }
        });
      } else {
        // El backend retorna mensajes específicos:
        // - "Usuario no autorizado" si no está en la BD
        // - "Token inválido" si hay problemas con Google
        console.error('❌ Error de autenticación:', authResponse.message);
        
        dispatch({
          type: 'AUTH_LOGIN_ERROR',
          payload: { 
            error: authResponse.message || 'Error en autenticación con Google'
          }
        });
      }
      
    } catch (error) {
      console.error('❌ Error en autenticación:', error);
      dispatch({
        type: 'AUTH_LOGIN_ERROR',
        payload: { 
          error: error instanceof Error ? error.message : 'Error desconocido en autenticación' 
        }
      });
    }
  };

  const handleError = () => {
    console.error('❌ Error en Google Login');
    dispatch({
      type: 'AUTH_LOGIN_ERROR',
      payload: { error: 'Error al iniciar sesión con Google. Intenta de nuevo.' }
    });
  };

  return (
    <div className="google-login-wrapper">
      <div className="google-login-container">
        {auth.isLoading ? (
          <div className="loading-spinner">
            <p>Autenticando...</p>
          </div>
        ) : (
          <GoogleOAuthLogin
            onSuccess={handleSuccess}
            onError={handleError}
            useOneTap={false}
            theme="outline"
            size="large"
            text="continue_with"
            shape="rectangular"
            logo_alignment="left"
            width="350"
          />
        )}
      </div>
      
      {auth.error && (
        <div className="login-error">
          <p className="error-text">{auth.error}</p>
        </div>
      )}
      
      <div className="login-help">
        <p className="help-text">
          Solo usuarios autorizados pueden acceder a esta aplicación
        </p>
      </div>
    </div>
  );
};

export default GoogleLogin;